import PageProtectedLayout from "../../../components/Page/PageProtectedLayout";
import SectionDashboardBlood from "../../../components/Section/SectionDashboardBlood";
import SectionEssentials from "./SectionVitals/SectionEssentials";
import { useTranslation } from "../../../language";
import { useTheme } from "@mui/material";

export default function VitalsWelcome() {

    const { t, language } = useTranslation();

return (

    <PageProtectedLayout
    
    headline={t('page_hl_biometric_vitals')}
    specify={t('page_sp_body_blood_pressure')}
    headlineVariant="h4"

     >
    
          {/* Main Page Content */}
          
            <SectionEssentials />
         
          
        </PageProtectedLayout>
    
      );
    }